import React, { useRef, useState } from 'react';
import { FaTimes, FaFileInvoice } from 'react-icons/fa';
import { toast } from 'react-toastify';
import api from '~/services/api';

import {
  Container,
  Content,
  Header,
  Form,
  InputGroup,
  Button,
  CancelButton,
  CheckboxGroup,
} from './styles';

const GenerateBilletsModal = ({
  isOpen,
  setIsOpen,
  monthlyPaymentIds,
  onSuccess,
  isSingle = false,
}) => {
  const [competenceDate, setCompetenceDate] = useState(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
  });

  const initialCompetenceDateRef = useRef(null);
  const previousCompetenceDateRef = useRef(null);

  if (!initialCompetenceDateRef.current) {
    initialCompetenceDateRef.current = competenceDate;
  }

  const [currentDate /* setCurrentDate */] = useState(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isClosingFee, setIsClosingFee] = useState(false);

  const handleClosingFeeChange = event => {
    const { checked } = event.target;
    setIsClosingFee(checked);

    if (checked) {
      previousCompetenceDateRef.current = competenceDate;
      const baseDate = competenceDate || initialCompetenceDateRef.current;
      const [year] = (baseDate || '').split('-');
      if (year) {
        setCompetenceDate(`${year}-12`);
      }
    } else {
      const restoredDate =
        previousCompetenceDateRef.current || initialCompetenceDateRef.current;
      if (restoredDate) {
        setCompetenceDate(restoredDate);
      }
      previousCompetenceDateRef.current = null;
    }
  };

  const handleClose = () => {
    if (!isSubmitting) {
      setIsOpen(false);
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (!competenceDate) {
      toast.error('Por favor, selecione a data de competência.', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    if (!currentDate) {
      toast.error('Por favor, selecione a data atual.', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    if (!monthlyPaymentIds || (monthlyPaymentIds.length === 0 && isSingle)) {
      toast.error('Nenhuma mensalidade disponível para gerar cobranças.', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    setIsSubmitting(true);

    try {
      // Formatar a competência para MM/YYYY
      const [year, month] = competenceDate.split('-');
      const formattedMonth = isClosingFee ? '13' : month;
      const formattedCompetence = `${formattedMonth}/${year}`;

      const response = await api.post('/monthly-payments/create-billets', {
        monthly_payment_ids: monthlyPaymentIds,
        competence: formattedCompetence,
        is_closing_fee: isClosingFee,
      });

      toast.success('Cobranças geradas com sucesso!', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });

      if (onSuccess) {
        onSuccess(response.data);
      }

      handleClose();
    } catch (error) {
      toast.error(
        `Falha ao gerar cobranças: ${error.response?.data?.error ||
          error.response?.data?.message ||
          error.message ||
          'Erro desconhecido'}`,
        {
          position: toast.POSITION.BOTTOM_RIGHT,
        }
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <Container>
      <Content>
        <Header>
          <div className="header-content">
            <FaFileInvoice size={24} color="#01579b" />
            <h3>{isSingle ? 'Gerar Cobrança' : 'Gerar Todas as Cobranças'}</h3>
          </div>
          <button
            type="button"
            onClick={handleClose}
            className="close-button"
            disabled={isSubmitting}
          >
            <FaTimes size={18} color="#e53935" />
          </button>
        </Header>

        <Form onSubmit={handleSubmit}>
          <div className="info-section">
            <p>
              {isSingle
                ? 'Será gerada uma cobrança para esta mensalidade.'
                : `Serão geradas cobranças para todas as mensalidades.`}
            </p>
          </div>

          <InputGroup>
            <label htmlFor="competenceDate">Data de Competência</label>
            <input
              id="competenceDate"
              type="month"
              value={competenceDate}
              onChange={e => setCompetenceDate(e.target.value)}
              disabled={isSubmitting || isClosingFee}
              required
            />
          </InputGroup>

          <CheckboxGroup>
            <input
              id="closingFee"
              type="checkbox"
              checked={isClosingFee}
              onChange={handleClosingFeeChange}
              disabled={isSubmitting}
            />
            <label htmlFor="closingFee">Taxa de Encerramento</label>
          </CheckboxGroup>

          {/* <InputGroup>
            <label htmlFor="currentDate">Data Atual</label>
            <input
              id="currentDate"
              type="date"
              value={currentDate}
              onChange={e => setCurrentDate(e.target.value)}
              disabled={isSubmitting}
              required
            />
          </InputGroup> */}

          <div className="button-group">
            <CancelButton
              type="button"
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Cancelar
            </CancelButton>
            <Button type="submit" disabled={isSubmitting}>
              <FaFileInvoice />
              {isSubmitting ? 'Gerando...' : 'Confirmar'}
            </Button>
          </div>
        </Form>
      </Content>
    </Container>
  );
};

export default GenerateBilletsModal;
